module.exports = __webpack_public_path__ + "static/media/learn.52921df4.svg";